import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Axios from "axios";

import { getServiceUrl } from "config";

let serviceInstance = Axios.create({
  baseURL: getServiceUrl(),
});

export interface FileThumbnailItem {
  [index: string]: string;
}

const getImageDisplayUrlByKey = createAsyncThunk<FileThumbnailItem, string, {}>(
  "fileThumbnails/getByKey",
  async (key: string) => {
    const response = await serviceInstance.get("/displayUrl", {
      params: { key },
    });
    return { [key]: response.data.displayUrl } as FileThumbnailItem;
  }
);

const initialState: FileThumbnailItem = {};

const fileThumbnailsSlice = createSlice({
  name: "fileThumbnails",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getImageDisplayUrlByKey.fulfilled, (state, action) => {
      return { ...state, ...action.payload };
    });
    builder.addCase(getImageDisplayUrlByKey.rejected, (state, action) => {
      console.log("Unable to retrieve thumbnail");
    });
  },
});

export { getImageDisplayUrlByKey };
export default fileThumbnailsSlice.reducer;
